module.exports = __webpack_public_path__ + "img/Share of Voice.cff49c78.svg";